/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { TagActiveStatus } from "../../../components/badge-and-tag/ERP";
import {
  Row,
  Col,
  Space,
  Descriptions,
  Tabs,
  Divider,
  Button,
  Input,
  Table,
  Card,
  Flex,
  Typography,
} from "antd";

import {
  ArrowLeftOutlined,
  EditOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { ModalInkFormat } from "../../../components/modal/ERP/ink-format/";
import ModalMaterial from "../../../components/modal/ERP/material/ModalMaterial";
import { GiMetalBar } from "react-icons/gi";

// import SamplePreparationService from "../../service/SamplePreparation.service.js";
import PGService from "../../../service/ERP/PG.service.js";
import { capitalized, BACKEND_URL_MAIN } from "../../../utils/util.js";
import { listcolumnView } from "./model.js";

import dayjs from "dayjs";

const pgService = PGService();
export default function PGView() {
  const navigate = useNavigate();
  const location = useLocation();

  const { config } = location.state || { config: null };
  const dividerProp = {
    orientation: "left",
    style: { marginBlock: 10 },
    className: "!border-black",
  };
  const mngConfig = {
    title: "",
    textOk: null,
    textCancel: null,
    action: "create",
    code: null,
  };

  const [masters, setMasters] = useState({});
  const [openInkModal, setOpenInkModal] = useState(false);
  const [listMaterial, setlistMaterial] = useState([]);

  /// upload image
  const [previewImage, setPreviewImage] = useState(null);

  const [openModalMaterial, setOpenModalMaterial] = useState(false);

  const gettingPGData = () => {
    pgService.get(config?.code).then(async (res) => {
      const { data, file,pllist } = res.data;
      setMasters(data);
      setlistMaterial(pllist);


      let fileurl = file.map((data) => ({
        ...data,
        file_name:
          `${BACKEND_URL_MAIN}/uploads/ERP/Items/` +
          masters.pg_code +
          "/" +
          data.file_name,
      }));
      // console.log(fileurl) ;
      const formattedFileList = fileurl.map((data) => ({
        img_id: data.img_id,
        uid: data.uid,
        name: data.name,
        status: "done",
        url: data.file_name,
      }));

      // setPreviewImage(formattedFileList[0].url || formattedFileList[0].preview);
    });
  };

  const hendleClose = () => {
    navigate("/ERP/packing-goods", { replace: true });
  };

  const handleEditPackingGoods = () => {
    navigate("/ERP/packing-goods/manage/edit", {
      state: {
        config: {
          ...mngConfig,
          title: "Edit Packing Goods",
          action: "edit",
          code: masters?.id,
        },
      },
    });
  };

  useEffect(() => {
    // console.log(config);
    if (!config) {
      hendleClose();
      return;
    }
    gettingPGData();

    return () => {};
  }, [previewImage]);

  const onSelectInkFormat = (value) => {
    console.log(value);
    setMasters((prev) => ({
      ...prev,
      ink_id: value.ink_id,
      ink_name: value.ink_name,
    }));
  };

  const handleChooseItems = (v) => {
    // const newData = (r) => {
    //   const newData = [...bomReducer];
    //   const ind = newData.findIndex((item) => ProductValue.seq === item?.seq);
    //   const item = newData[ind];
    //   newData.splice(ind, 1, {
    //     ...item,
    //     ...v,
    //   });
    //   return newData;
    // };
    // dispatch(setValue([...newData()]));
  };

  const basicItems = [
    { label: "PG Code", children: masters?.pg_code },
    { label: "PG Thai Name", children: masters?.pg_name },
    { label: "Customer PG Name", children: masters?.pg_stname_cus },
    { label: "PG Invoice Name", children: masters?.pg_ivname },
    {
      label: "Finished Goods",
      children:
        masters?.fg_code || masters?.fg_name
          ? `${masters?.fg_code ?? ""} ${
              masters?.fg_name ? "/ " + masters?.fg_name : ""
            }`
          : "",
    },
    {
      label: "Packing",
      children:
        masters?.packing_code || masters?.packing_name
          ? `${masters?.packing_code ?? ""} ${
              masters?.packing_name ? "/ " + masters?.packing_name : ""
            }`
          : "",
    },
    { label: "Unit", children: masters?.unit },
    { label: "Brand", children: masters?.brand_name || masters?.brand_code },
    { label: "สารก่อภูมิแพ้", children: masters?.allergen  },
  ];

  const calItems = [
    { label: "Unit/cs", children: masters?.unit_cs },
    { label: "Gross Weight", children: masters?.gross_wt },
  ];

  const otherItems = [
    {
      label: "รูปสินค้า",
      children: previewImage ? (
        <div style={{ display: "flex", justifyContent: "left" }}>
          <img
            style={{
              width: "250px",
              objectFit: "contain",
              border: "1px solid #d9d9d9",
              padding: "1px",
            }}
            src={previewImage}
            alt="Product"
          />
        </div>
      ) : (
        "No Image"
      ),
      span: { xs: 1, sm: 3, md: 3, lg: 3, xl: 3, xxl: 3 },
    },
    {
      label: "สถานะการใช้งาน",
      children: <TagActiveStatus result={masters.active_status} />,
      span: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1, xxl: 1 },
    },
    {
      label: "Remark",
      children: masters?.remarks,
      span: { xs: 1, sm: 2, md: 2, lg: 2, xl: 2, xxl: 2 },
    },
    { label: "Created By", children: masters?.created_by_name },
    {
      label: "Created At",
      children: masters?.created_date
        ? dayjs(masters?.created_date).format("DD/MM/YYYY HH:mm:ss")
        : "",
    },
    { label: "Updated By", children: masters?.updated_by_name },
    {
      label: "Updated At",
      children: masters?.updated_date
        ? dayjs(masters?.updated_date).format("DD/MM/YYYY HH:mm:ss")
        : "",
    },
  ];

  /** settimg child component */
  const ButtonActionSrDetailLeft = (
    <Space
      gap="small"
      align="center"
      style={{ display: "flex", justifyContent: "start" }}
    >
      <Button
        style={{ width: 120 }}
        icon={<ArrowLeftOutlined />}
        onClick={() => {
          hendleClose();
        }}
      >
        กลับ
      </Button>
    </Space>
  );

  const ButtonActionSrDetailRight = (
    <>
      <Space
        gap="small"
        align="center"
        className="flex justify-start lg:justify-end md:justify-end"
      >
        <div style={{ display: "flex", gap: ".78rem", flexWrap: "wrap" }}>
          <Button
            style={{
              borderColor: "#52c41a",
              color: "#fff",
              background: "#52c41a",
            }}
            icon={<EditOutlined />}
            onClick={handleEditPackingGoods}
          >
            Edit Packing Goods
          </Button>
        </div>
      </Space>
    </>
  );

  const BasicData = (
    <>
      <Divider {...dividerProp}>ข้อมูลพื้นฐาน</Divider>
      <Descriptions
        bordered
        column={{ xs: 1, sm: 2, md: 3, lg: 3, xl: 3, xxl: 3 }}
        items={basicItems}
      />
    </>
  );

  const MasterContent = (
    <>
      {BasicData}

      <Divider {...dividerProp}>ข้อมูลใช้คำนวน</Divider>
      <Descriptions
        bordered
        column={{ xs: 1, sm: 2, md: 3, lg: 3, xl: 3, xxl: 3 }}
        items={calItems}
      />

      <Divider {...dividerProp}>Other Data</Divider>
      <Descriptions
        bordered
        column={{ xs: 1, sm: 2, md: 3, lg: 3, xl: 3, xxl: 3 }}
        items={otherItems}
      />
    </>
  );

  const handleAdd = () => {
    // setOpenInkModal(true);
    setOpenModalMaterial(true);
    // const newRow = {
    //   seq: listMaterial.length + 1, // กำหนด seq ใหม่
    //   qty: 1, // ค่าเริ่มต้น
    //   pk_code: "", // ค่าเริ่มต้นสำหรับรหัสวัตถุดิบ
    //   pk_name: "", // ค่าเริ่มต้นสำหรับชื่อวัตถุดิบ
    //   typename: "", // ค่าเริ่มต้นสำหรับประเภท
    //   unit: "", // ค่าเริ่มต้นสำหรับหน่วย
    // };
  };

  const TitleTable = (
    <Flex className="width-100" align="center">
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start" align="center">
          <Typography.Title className="m-0 !text-zinc-800" level={3}>
            List of Packing Information
          </Typography.Title>
        </Flex>
      </Col>
      <Col span={12} style={{ paddingInline: 0 }}>
        <Flex gap={4} justify="end">
          <Col span={12} style={{ display: "flex", justifyContent: "end" }}>
            {/* <Button
              className="bn-success-outline"
              size="default"
              style={{ display: "flex", alignItems: "center" }}
              icon={
                <GiMetalBar
                  style={{
                    fontSize: "1.15rem",
                    marginRight: 4,
                    verticalAlign: "middle",
                    marginBottom: 2,
                  }}
                />
              }
              onClick={() => handleAdd()}
            >
              Add Packing Information
            </Button> */}
          </Col>
        </Flex>
      </Col>
    </Flex>
  );

  const MaterialTableContent = (
    <>
      <Card>
        <Space
          direction="vertical"
          size="middle"
          style={{ display: "flex", position: "relative" }}
        >
          <Table
            title={() => TitleTable}
            // components={componentsEditable}
            // rowClassName={() => "editable-row"}
            bordered
            dataSource={listMaterial || []}
            columns={listcolumnView()}
            pagination={false}
            rowKey="seq"
            scroll={{ x: "max-content" }}
            size="small"
            // summary={(_) => TableSummary()}
          />
        </Space>
      </Card>
    </>
  );

  const inkItems = [
    { label: "จุดพิมพ์รหัส", children: masters?.print_point || "-" },
    { label: "Ink Format Name", children: masters?.ink_name || "-" },
    { label: "บรรทัดที่ 1", children: masters?.ink_description_1 || "-" },
    { label: "บรรทัดที่ 2", children: masters?.ink_description_2 || "-" },
    { label: "บรรทัดที่ 3", children: masters?.ink_description_3 || "-" },
    { label: "ตำแหน่งพิมพ์", children: masters?.ink_position || "-" },
    { label: "สีหมึก", children: masters?.ink_color || "-" },
    { label: "หมายเหตุอิงค์", children: masters?.ink_remark || "-" },
  ];

  const PackingInformationContent = (
    <>
      {BasicData}
      <Divider {...dividerProp}>รูปแบบอิงค์</Divider>
      <Descriptions
        bordered
        column={{ xs: 1, sm: 2, md: 3, lg: 3, xl: 3, xxl: 3 }}
        items={inkItems}
      />
      <Divider {...dividerProp}>รายละเอียด</Divider>
      {MaterialTableContent}
    </>
  );

  const items = [
    {
      key: "1",
      label: "ข้อมูลพื้นฐาน",
      children: MasterContent,
    },
    {
      key: "2",
      label: "มาตรฐานการปิดฉลาก",
      children: PackingInformationContent,
    },
  ];

  return (
    <>
      <Space
        direction="vertical"
        size="middle"
        style={{
          display: "flex",
          position: "relative",
          paddingInline: "1.34rem",
        }}
        className="sample-preparation-view"
      >
        <Row
          gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
          className="m-0"
        >
          <Col xs={24} sm={24} md={12} lg={12} xl={12} className="px-0">
            {ButtonActionSrDetailLeft}
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12} className="px-0">
            {ButtonActionSrDetailRight}
          </Col>
        </Row>

        <Tabs
          hideAdd
          defaultActiveKey="1"
          // activeKey={activeKey}
          items={items}
        />

        <Row
          gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
          className="mx-0 mb-4"
        >
          <Col xs={24} sm={24} md={12} lg={12} xl={12} className="px-0">
            {ButtonActionSrDetailLeft}
          </Col>
        </Row>
      </Space>
      {openInkModal && (
        <ModalInkFormat
          show={openInkModal}
          close={() => setOpenInkModal(false)}
          pgCode={masters?.pg_code}
          values={(res) => onSelectInkFormat(res)}
        />
      )}

      {openModalMaterial && (
        <ModalMaterial
          show={openModalMaterial}
          close={() => {
            setOpenModalMaterial(false);
          }}
          values={(v) => {
            handleChooseItems(v);
          }}
        ></ModalMaterial>
      )}
    </>
  );
}
